<template>
  <v-dialog max-width="1000px" persistent v-model="dialog" scrollable>
    <v-card v-if="form != null">
      <v-toolbar dark dense>
        <v-toolbar-title class="headline">{{ formTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="$emit('setDialog', false) && $emit('setEditIndex', -1)"
          >close</v-icon
        >
      </v-toolbar>
      <v-card-text style="height: auto; padding: 0">
        <v-form v-model="valid" ref="form">
          <v-layout row wrap>
            <v-flex xs6>
              <v-card-text>
                <v-text-field
                  class="mt-4"
                  v-model="form.package_name"
                  label="Package name"
                  :rules="[(v) => v == '0' || !!v || 'required']"
                  hide-details
                ></v-text-field>

                <v-text-field
                  class="mt-4"
                  type="number"
                  v-model="form.package_extra_transport_price"
                  label="Extra transport price (THB)"
                  :rules="[
                    (v) => v == '0' || !!v || 'required',
                    (v) => v >= '0' || 'must be more than 0',
                  ]"
                  hide-details
                ></v-text-field>
                <v-text-field
                  class="mt-4"
                  v-model="form.package_commission"
                  label="Commission(%)"
                  :rules="[(v) => v == '0' || !!v || 'required']"
                  hide-details
                ></v-text-field>
                <v-text-field
                  class="mt-4"
                  v-model="form.package_withdrawal_max"
                  label="Withdrawal-max"
                  :rules="[(v) => v == '0' || !!v || 'required']"
                  hide-details
                ></v-text-field>
                <v-text-field
                  class="mt-4"
                  v-model="form.package_fee_withdrawal"
                  label="Fee Withdrawal"
                  :rules="[(v) => v == '0' || !!v || 'required']"
                  hide-details
                ></v-text-field>
                <v-text-field
                  class="mt-4"
                  v-model="form.package_money_to_system"
                  label="Money into system"
                  :rules="[(v) => v == '0' || !!v || 'required']"
                  hide-details
                ></v-text-field>
                <v-text-field
                  class="mt-4"
                  v-model="form.package_fee_credit_card"
                  label="Fee Credit card"
                  :rules="[(v) => v == '0' || !!v || 'required']"
                  hide-details
                ></v-text-field>
                <v-text-field
                  class="mt-4"
                  v-model="form.package_withdrawal_date"
                  label="Withdrawal Date"
                  :rules="[(v) => v == '0' || !!v || 'required']"
                  hide-details
                ></v-text-field>
                <v-select
                  class="mt-4"
                  item-value="province_name_th"
                  v-model="form.package_area_delivery"
                  :items="area_delivery"
                  item-text="province_name_th"
                  label="Area Delivery"
                  :rules="[(v) => v == '0' || !!v || 'required']"
                  hide-details
                ></v-select>
                <v-text-field
                  class="mt-4"
                  v-model="form.package_monthly_shop_promotion"
                  label="Monthly Shop Promotion"
                  :rules="[(v) => v == '0' || !!v || 'required']"
                  hide-details
                ></v-text-field>
              </v-card-text>
            </v-flex>
            <v-flex xs6>
              <v-card-text>
                <v-select
                  class="mt-4"
                  v-model="form.package_payment_method"
                  label="Pay at store"
                  color="primary"
                  :items="packagePaymentMethodList"
                  item-text="name"
                  item-value="value"
                  :rules="[(v) => v == '0' || !!v || 'required']"
                  hide-details
                ></v-select>
                <v-text-field
                  class="mt-4"
                  v-model="form.package_promotion_from_weserve"
                  label="Promotion from WESERVE"
                  :rules="[(v) => v == '0' || !!v || 'required']"
                  hide-details
                ></v-text-field>
                <v-text-field
                  class="mt-4"
                  v-model="form.package_item_recommended"
                  label="Recommended Product Features"
                  :rules="[(v) => v == '0' || !!v || 'required']"
                  hide-details
                ></v-text-field>
                <v-text-field
                  class="mt-4"
                  v-model="form.package_item_bestseller"
                  label="Popular Product Features"
                  :rules="[(v) => v == '0' || !!v || 'required']"
                  hide-details
                ></v-text-field>
                <v-select
                  class="mt-4"
                  item-value="value"
                  v-model="form.package_standard_shop_system"
                  :items="standard_shop_system"
                  item-text="name"
                  label="Standard Shop System"
                  :rules="[(v) => v == '0' || !!v || 'required']"
                  hide-details
                ></v-select>
                <v-select
                  class="mt-4"
                  item-value="value"
                  v-model="form.package_review_rate"
                  :items="review_rate"
                  item-text="name"
                  label="Review Rate"
                  :rules="[(v) => v == '0' || !!v || 'required']"
                  hide-details
                ></v-select>
                <v-select
                  class="mt-4"
                  item-value="value"
                  v-model="form.package_blog"
                  :items="blog"
                  item-text="name"
                  label="Blog Editors from We Serve /Monthly"
                  :rules="[(v) => v == '0' || !!v || 'required']"
                  hide-details
                ></v-select>
                <v-select
                  class="mt-4"
                  item-value="value"
                  v-model="form.package_online_marketing"
                  :items="online_marketing"
                  item-text="name"
                  label="Online Marketing (FB or IG) /Monthly"
                  :rules="[(v) => v == '0' || !!v || 'required']"
                  hide-details
                ></v-select>
                <v-select
                  class="mt-4"
                  item-value="value"
                  v-model="form.package_food_photo"
                  :items="food_photo"
                  item-text="name"
                  label="Food Photo"
                  :rules="[(v) => v == '0' || !!v || 'required']"
                  hide-details
                ></v-select>
                <v-text-field
                  class="mt-4"
                  v-model="form.package_monthly_fee"
                  label="Monthly Fee"
                  :rules="[(v) => v == '0' || !!v || 'required']"
                  hide-details
                ></v-text-field>
              </v-card-text>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" :disabled="isEditPackage" flat @click="cancel()"
          >Cancel</v-btn
        >
        <v-btn color="green" @click="save()" :disabled="isEditPackage" flat
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["dialog", "editedIndex", "form"],
  data() {
    return {
      valid: true,
      pagination: {},
      commission: "",
      area_delivery: [],
      packagePaymentMethodList: [
        { name: "Auto transfer", value: 1 },
        { name: "Pay at store", value: 2 },
        { name: "Pay at store (Partner)", value: 3 },
      ],
      standard_shop_system: [
        {
          name: "None",
          value: 0,
        },
        {
          name: "Yes",
          value: 1,
        },
      ],
      review_rate: [
        {
          name: "None",
          value: 0,
        },
        {
          name: "Yes",
          value: 1,
        },
      ],
      blog: [
        {
          name: "None",
          value: 0,
        },
        {
          name: "1",
          value: 1,
        },
        {
          name: "2",
          value: 2,
        },
        {
          name: "3",
          value: 3,
        },
        {
          name: "4",
          value: 4,
        },
        {
          name: "5",
          value: 5,
        },
        {
          name: "6",
          value: 6,
        },
      ],
      online_marketing: [
        {
          name: "None",
          value: 0,
        },
        {
          name: "1",
          value: 1,
        },
        {
          name: "2",
          value: 2,
        },
        {
          name: "3",
          value: 3,
        },
        {
          name: "4",
          value: 4,
        },
        {
          name: "5",
          value: 5,
        },
        {
          name: "6",
          value: 6,
        },
      ],
      food_photo: [
        {
          name: "None",
          value: 0,
        },
        {
          name: "Yes",
          value: 1,
        },
      ],
    };
  },
  watch: {
    async dialog() {
      if (this.dialog == true) {
        this.$refs.form.resetValidation();
        this.area_delivery = await this.$store.dispatch(
          "fetchProvinceBack/getData"
        );
      }
    },
  },
  computed: {
    ...mapGetters({
      isEditPackage: "isEditPackage",
    }),
    formTitle() {
      return this.editedIndex === -1 ? "New Package" : "Edit Package";
    },
  },
  methods: {
    cancel() {
      this.$emit("setDialog", false);
      this.$emit("setEditIndex", -1);
      if (this.editedIndex != -1) {
        this.$emit("cancelEdit");
      }
    },
    save() {
      if (this.$refs.form.validate() == false) return;
      this.form.package_extra_transport_price = parseFloat(
        this.form.package_extra_transport_price
      );
      if (this.editedIndex == -1) {
        this.$store.dispatch("fetchPackageBack/addPackage", {
          form: this.form,
          province: this.$route.params.province,
        });
        this.$emit("setEditIndex", -1);
        this.$emit("setDialog", false);
      } else {
        this.$store.dispatch("fetchPackageBack/editPackage", {
          form: this.form,
          province: this.$route.params.province,
        });
        this.$emit("setEditIndex", -1);
        this.$emit("setDialog", false);
      }
    },
  },
};
</script>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
